<template>
    <b-container>
        <b-card title="Previous orders">
            <b-table show-empty responsive :fields="fields" :busy="loading" :items="orders">
                <template v-slot:empty="scope">
                    <div class="d-block text-center">
                        <span class="d-block h2"><ion-icon name="sad-outline"></ion-icon></span>
                        <span class="d-block">You have no previous orders.</span>
                    </div>
                </template>
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template v-slot:cell(order_total)="data">
                    £{{ formatMoney(data.value) }}
                </template>

                <template v-slot:cell(action)="data">
                    <router-link :to="{path: '/previous-orders/' + data.item.order_no}">View Order</router-link>
                </template>
            </b-table>
        </b-card>
    </b-container>
</template>

<script>
    export default {
        name: "PreviousOrders",

        data(){
            return {
                fields: [
                    {key: 'table_no'},
                    {key: 'order_no'},
                    {key: 'order_total'},
                    {key: 'action'}
                ],
                loading: false,
                orders: []
            }
        },

        mounted() {
            this.getUserOrders()
        },

        methods: {
            getUserOrders(){
                this.loading = true;
                axios.get('/user/orders').then(response => {
                    this.orders = response.data;
                    console.log(this.orders)
                    this.loading = false;
                })
            },

            formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            },
        }
    }
</script>

<style scoped>

</style>